// extracted by mini-css-extract-plugin
export default {"container":"CreateUserPopup_container__i7Et0","title":"CreateUserPopup_title__6B2Ku"};